import { render } from "./ThankYouPageFantasy.vue?vue&type=template&id=4e6d1e8a&scoped=true"
import script from "./ThankYouPageFantasy.vue?vue&type=script&lang=js"
export * from "./ThankYouPageFantasy.vue?vue&type=script&lang=js"

import "./ThankYouPageFantasy.vue?vue&type=style&index=0&id=4e6d1e8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6d1e8a"]])

export default __exports__